<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="policy-summary">
        <h1 class="policy-summary__title">
            隐私政策摘要-启蒙好课
        </h1>

        <p class="policy-summary__intro">
            高途教育科技集团有限公司（以下简称“我们”）深知个人信息对您和孩子的重要性。为了让您更清晰地了解我们如何收集、使用和保护个人信息，我们特别制作了本摘要。完整版内容请阅读
            <router-link class="policy-summary__link" to="/policy">
                《个人信息保护政策》
            </router-link>
            与
            <router-link class="policy-summary__link" to="/policychild">
                《儿童隐私政策》
            </router-link>
            。
        </p>

        <section class="policy-summary__section">
            <h2>一、个人信息收集与使用规则</h2>

            <h3>账号注册</h3>
            <ul>
                <li><strong>学习教育基本服务：</strong>依据国家规定，本App属于学习教育类，必要个人信息为注册用户移动电话号码。</li>
                <li><strong>可选完善信息：</strong>您可以自愿填写昵称、性别、生日年月，拒绝提供不影响基本功能使用。</li>
                <li>
                    详情请见：<router-link class="policy-summary__link" to="/policycollectlist">
                        《个人信息收集清单》
                    </router-link>
                </li>
            </ul>

            <h3>系统权限使用（核心业务功能）</h3>
            <p>为了保证产品的核心教学与互动体验，我们会动态申请以下关键系统权限：</p>
            <div class="policy-summary__table-wrap">
                <table class="policy-summary__table">
                    <thead>
                        <tr>
                            <th>权限</th>
                            <th>业务功能</th>
                            <th>授权方式</th>
                            <th>是否可关闭</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CAMERA</td>
                            <td>拍照得到用户影像，合成朗诵作品</td>
                            <td>运行时动态授权</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>RECORD_AUDIO</td>
                            <td>录音评测、语音交互</td>
                            <td>运行时动态授权</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>READ_EXTERNAL_STORAGE<br>(maxSdk=32)</td>
                            <td>客服中心或换头像等场景读取本地图片/音频/视频资源，Android 13以下</td>
                            <td>运行时动态授权</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>RECEIVE_BOOT_COMPLETED</td>
                            <td>用于提升后台播放音频的稳定性</td>
                            <td>手动设置</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>WRITE_EXTERNAL_STORAGE</td>
                            <td>个人中心保存作品到本地、保存奖状到本地等场景，Android 10及以下</td>
                            <td>运行时动态授权</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>READ_MEDIA_IMAGES /<br>READ_MEDIA_AUDIO /<br>READ_MEDIA_VIDEO</td>
                            <td>Android 13+ 替代READ_EXTERNAL_STORAGE，读取媒体文件</td>
                            <td>运行时动态授权</td>
                            <td>是，可在系统设置中关闭</td>
                        </tr>
                        <tr>
                            <td>INTERNET</td>
                            <td>网络请求、资源下载、数据上报</td>
                            <td>安装时自动授权</td>
                            <td>否，基础权限</td>
                        </tr>
                        <tr>
                            <td>ACCESS_NETWORK_STATE</td>
                            <td>检测网络状态，优化视频加载策略</td>
                            <td>安装时自动授权</td>
                            <td>否，基础权限</td>
                        </tr>
                        <tr>
                            <td>ACCESS_WIFI_STATE</td>
                            <td>判断WiFi状态，视频播放质量优化</td>
                            <td>安装时自动授权</td>
                            <td>否，基础权限</td>
                        </tr>
                        <tr>
                            <td>WAKE_LOCK</td>
                            <td>课程播放时保持屏幕常亮</td>
                            <td>安装时自动授权</td>
                            <td>是，可在系统设置中管理</td>
                        </tr>
                        <tr>
                            <td>FOREGROUND_SERVICE</td>
                            <td>后台音频播放服务、作品上传服务</td>
                            <td>安装时自动授权</td>
                            <td>是，Android 9+ 需手动开启</td>
                        </tr>
                        <tr>
                            <td>REQUEST_INSTALL_PACKAGES</td>
                            <td>应用内根据用户安装情况确定下载关联APP还是直接打开</td>
                            <td>运行时授权，需用户确认</td>
                            <td>是，需</td>
                        </tr>
                        <tr>
                            <td>com.vivo.notification.permission.BADGE_ICON</td>
                            <td>VIVO手机推送消息角标显示</td>
                            <td>安装时自动授权</td>
                            <td>是，通知设置中管理</td>
                        </tr>
                        <tr>
                            <td>com.huawei.android.launcher.permission.CHANGE_BADGE</td>
                            <td>华为手机推送消息角标显示</td>
                            <td>安装时自动授权</td>
                            <td>是，通知设置中管理</td>
                        </tr>
                        <tr>
                            <td>com.xiaomi.sdk.permission.APP</td>
                            <td>小米联运SDK必需权限</td>
                            <td>安装时自动授权</td>
                            <td>否，SDK内部使用</td>
                        </tr>
                        <tr>
                            <td>READ_PHONE_STATE<br>(xiaomi模块)</td>
                            <td>小米SDK设备标识获取</td>
                            <td>运行时动态授权</td>
                            <td>是</td>
                        </tr>
                        <tr>
                            <td>FLASHLIGHT</td>
                            <td>部分前端页面有扫码功能，扫码时开启闪光灯辅助照明</td>
                            <td>通过CAMERA权限间接控制</td>
                            <td>是</td>
                        </tr>
                        <tr>
                            <td>VIBRATE</td>
                            <td>扫码成功震动反馈、游戏交互反馈</td>
                            <td>安装时自动授权</td>
                            <td>是，可在系统设置关闭触感</td>
                        </tr>
                        <tr>
                            <td>GET_TASKS</td>
                            <td>打开推送消息时，需要先判断当前APP是否在运行</td>
                            <td>安装时自动授权</td>
                            <td>否，SDK内部使用</td>
                        </tr>
                        <tr>
                            <td>SYSTEM_ALERT_WINDOW</td>
                            <td>悬浮窗权限，允许悬浮在应用上的提示窗口，第三方SDK内部使用</td>
                            <td>在设置中手动授权</td>
                            <td>是，可在系统设置关闭</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h3>设备信息收集（自动收集）</h3>
            <p>
                在应用前台与后台运行期间，为了保障音频后台播放的稳定性，安卓端App会收集您的：硬件型号、Android ID、操作系统版本号、OAID、IP地址、服务日志等。<!--
                -->我们承诺在后台状态下不会额外收集您的音频内容或敏感信息。
            </p>
        </section>

        <section class="policy-summary__section">
            <h2>二、第三方SDK数据共享明细</h2>
            <p>
                为了保障App的安全稳定运行及实现特定功能，我们接入了以下主要第三方SDK（详情请见：<!--
                --><router-link class="policy-summary__link" to="/policythirdshare">
                    《第三方信息共享清单》
                </router-link>）。所有第三方SDK均在您同意本政策后才会初始化并开始收集数据：
            </p>
            <ul>
                <li>
                    <strong>支付与一键登录：</strong>
                    <ul>
                        <li>支付宝/微信支付 SDK：用于购买课程时完成支付，保障支付安全。</li>
                        <li>闪验/运营商登录 SDK：获取IP、网卡、OAID、SIM卡信息，实现手机号码一键免密登录。</li>
                    </ul>
                </li>
                <li>
                    <strong>音视频与技术支持：</strong>
                    <ul>
                        <li>讯飞 SDK：收集设备号/IP/Android ID，用于语音评测功能。</li>
                        <li>阿里云播放器/OSS SDK：用于视频播放及保存用户上传的作品。</li>
                    </ul>
                </li>
                <li>
                    <strong>数据统计与广告归属：</strong>
                    <ul>
                        <li>
                            增长营销套件SDK（com.bytedance.bdtracker、com.bytedance.applog）/GrowingIO/友盟/听云/巨量引擎 SDK：<!--
                            -->收集设备标识符（Android ID/OAID/MAC等）及App内点击行为，用于产品优化、崩溃日志收集及广告投放监测。
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>手机厂商推送：</strong>
                    <ul>
                        <li>集成了腾讯TPNS、华为、小米、OPPO、vivo、魅族、荣耀等推送SDK，用于向您精准推送课程提醒和消息。</li>
                    </ul>
                </li>
            </ul>
        </section>

        <section class="policy-summary__section">
            <h2>三、您的核心权利</h2>
            <p>我们保障您对个人信息拥有的核心控制权。以下请求我们均将在<strong>15个工作日内</strong>做出答复：</p>
            <ul>
                <li><strong>查询、更正与删除：</strong>您有权发送邮件查询、更正或申请删除您的个人信息。</li>
                <li><strong>个人信息副本导出：</strong>您可以通过App内路径（我的 -> 家长中心 -> 账号管理 -> 个人信息导出）将个人信息发送至您的邮箱。</li>
                <li><strong>账户注销与撤回授权：</strong>您可以拨打客服电话4000910188申请注销账号，或撤回对隐私政策的同意。</li>
            </ul>
        </section>

        <section class="policy-summary__section">
            <h2>四、儿童隐私特别保护（未满14周岁）</h2>
            <p>我们始终坚持儿童利益优先原则，对不满14周岁的儿童实施更严格的保护措施：</p>
            <ul>
                <li><strong>监护人校验：</strong>在注册、充值、付费等环节，我们必须通过手机号、登录认证等措施校验监护人身份。</li>
                <li><strong>纯净教学环境：</strong>为了让孩子免受商业信息困扰，儿童账号内绝不加入任何网络游戏链接，也绝不推送与教学无关的广告信息。</li>
                <li><strong>信息安全防护：</strong>我们会利用技术手段监测并拦截站内信中的恶意、非法内容，全面保护儿童基本安全。</li>
            </ul>
        </section>

        <section class="policy-summary__section">
            <h2>五、联系我们</h2>
            <ul>
                <li><strong>产品运营方：</strong>高途教育科技集团有限公司</li>
                <li>
                    <strong>联系邮箱：</strong>
                    <a class="policy-summary__link" href="mailto:xuelu@gaotu.cn">xuelu@gaotu.cn</a>
                </li>
                <li>
                    <strong>联系电话：</strong>
                    <a class="policy-summary__link" href="tel:4000910188">400-091-0188</a>（15个工作日内回复）
                </li>
            </ul>
        </section>
    </div>
</template>

<script>

export default {
    name: 'PolicySummary',
    components: {
    },
    mounted() {
        document.title = '隐私政策摘要';
    },
};
</script>

<style scoped>
/*
 * 全站 rem 随 clientWidth/10 变化，横屏时宽度很大导致 rem 极大。
 * 本页正文统一用 px，避免横屏字号失控。
 */
.policy-summary {
    box-sizing: border-box;
    max-width: 672px;
    margin: 0 auto;
    padding: 24px 14px;
    font-size: 13px;
    line-height: 1.55;
    color: #333;
    text-align: left;
    -webkit-font-smoothing: antialiased;
}

.policy-summary__title {
    margin: 0 0 12px;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
    line-height: 1.35;
    color: #1a1a1a;
}

.policy-summary__intro {
    margin: 0 0 14px;
    text-indent: 2em;
}

.policy-summary__section {
    margin-bottom: 14px;
}

.policy-summary__section h2 {
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
}

.policy-summary__section h3 {
    margin: 10px 0 6px;
    font-size: 13px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
}

.policy-summary__section > p:first-of-type {
    margin: 0 0 6px;
}

.policy-summary__section > ul {
    margin: 0;
    padding-left: 18px;
}

.policy-summary__section ul ul {
    margin: 4px 0;
    padding-left: 18px;
}

.policy-summary__section li {
    margin-bottom: 5px;
}

.policy-summary__section li:last-child {
    margin-bottom: 0;
}

/* ── 权限表格 ── */
.policy-summary__table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
}

.policy-summary__table {
    width: 100%;
    min-width: 580px;
    border-collapse: collapse;
    font-size: 12px;
    line-height: 1.45;
}

.policy-summary__table th,
.policy-summary__table td {
    padding: 6px 8px;
    border: 1px solid #e0e0e0;
    text-align: left;
    vertical-align: top;
}

.policy-summary__table th {
    background: #f5f7fb;
    font-weight: 700;
    color: #1a1a1a;
    white-space: nowrap;
}

.policy-summary__table td:first-child {
    white-space: nowrap;
    font-family: monospace;
    font-size: 11px;
}

/* 手机横屏等「宽而矮」视口再压一档（避免桌面横屏被误缩小） */
@media (orientation: landscape) and (max-height: 520px) {
    .policy-summary {
        padding: 20px 12px 16px;
        font-size: 12px;
        line-height: 1.5;
    }

    .policy-summary__title {
        margin-bottom: 8px;
        font-size: 15px;
    }

    .policy-summary__intro {
        margin-bottom: 10px;
    }

    .policy-summary__section {
        margin-bottom: 10px;
    }

    .policy-summary__section h2 {
        font-size: 13px;
    }

    .policy-summary__section h3 {
        font-size: 12px;
    }

    .policy-summary__table {
        font-size: 11px;
    }

    .policy-summary__table th,
    .policy-summary__table td {
        padding: 4px 6px;
    }
}

.policy-summary__link {
    color: #3370ff;
    text-decoration: none;
    word-break: break-all;
}

.policy-summary__link:hover {
    text-decoration: underline;
}
</style>
